import React, { useState } from 'react';
import { Calendar, CheckCircle, Archive, History, Trash2 } from 'lucide-react';

const StudentDetailHistoryTab = ({
  archivedTasks,
  studentId,
  handleDeleteProgramPermanent,
}) => {
  const [pendingDeleteProgId, setPendingDeleteProgId] = useState(null);

  return (
    <>
      <div className="flex justify-between items-center mb-6 border-b border-slate-100 dark:border-slate-700 pb-4">
        <h3 className="font-bold text-lg text-slate-800 dark:text-white flex items-center gap-2">
          <History className="text-amber-500 dark:text-amber-400" /> Program Geçmişi
        </h3>
        <span className="text-xs font-bold text-slate-400 bg-slate-100 dark:bg-slate-700 px-3 py-1.5 rounded-full">
          {archivedTasks.length} kayıt
        </span>
      </div>
      {archivedTasks.length > 0 ? (
        <div className="space-y-3">
          {archivedTasks.map((prog) => (
            <div
              key={prog.id}
              className="border border-slate-100 dark:border-slate-700 rounded-2xl p-4 bg-slate-50 dark:bg-slate-800/40"
            >
              <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div className="flex items-center gap-2">
                  <span className="bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-400 text-xs font-bold px-3 py-1 rounded-lg">
                    {prog.day}
                  </span>
                  <span className="text-[10px] font-bold text-slate-400 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 px-2 py-1 rounded flex items-center gap-1">
                    <Calendar size={11} /> {prog.date || 'Tarih Yok'}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  {prog.completed ? (
                    <span className="flex items-center gap-1 text-emerald-600 dark:text-emerald-400 text-[10px] font-bold bg-emerald-50 dark:bg-emerald-900/30 px-2 py-1 rounded-full">
                      <CheckCircle size={11} /> Tamamlandı
                    </span>
                  ) : (
                    <span className="flex items-center gap-1 text-slate-400 text-[10px] font-bold bg-slate-100 dark:bg-slate-700 px-2 py-1 rounded-full">
                      Tamamlanmadı
                    </span>
                  )}
                  <span className="flex items-center gap-1 text-amber-600 dark:text-amber-400 text-[10px] font-bold bg-amber-50 dark:bg-amber-900/20 px-2 py-1 rounded-full">
                    <Archive size={11} /> Arşiv
                  </span>
                  {pendingDeleteProgId === prog.id ? (
                    <div className="flex items-center gap-1.5 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 px-3 py-1.5 rounded-xl">
                      <span className="text-[10px] font-bold text-red-700 dark:text-red-400">Silinsin mi?</span>
                      <button
                        onClick={() => { handleDeleteProgramPermanent(studentId, prog.id); setPendingDeleteProgId(null); }}
                        className="text-[10px] font-black text-white bg-red-500 hover:bg-red-600 px-2 py-0.5 rounded-lg transition-colors"
                      >
                        Evet
                      </button>
                      <button
                        onClick={() => setPendingDeleteProgId(null)}
                        className="text-[10px] font-black text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 px-2 py-0.5 rounded-lg transition-colors"
                      >
                        Hayır
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => setPendingDeleteProgId(prog.id)}
                      className="flex items-center gap-1 text-red-500 hover:text-red-700 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/40 px-2 py-1 rounded-full transition-colors text-[10px] font-bold"
                      title="Görevi Sil"
                    >
                      <Trash2 size={11} /> Sil
                    </button>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                {[
                  { label: 'Isınma', color: 'text-orange-500', value: prog.warmup },
                  { label: 'Ana Set', color: 'text-blue-500', value: prog.main },
                  { label: 'Soğuma', color: 'text-emerald-500', value: prog.cooldown },
                ].map((s) => (
                  <div key={s.label} className="bg-white dark:bg-slate-800 p-3 rounded-xl border border-slate-100 dark:border-slate-700">
                    <p className={`text-[9px] font-bold ${s.color} uppercase mb-1`}>{s.label}</p>
                    <p className="text-xs font-bold text-slate-500 dark:text-slate-400 line-through">
                      {s.value || '-'}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700">
          <History size={40} className="mx-auto text-slate-300 dark:text-slate-600 mb-4" />
          <p className="font-bold text-slate-500 dark:text-slate-400 mb-2">Geçmiş Program Yok</p>
          <p className="text-sm text-slate-400 dark:text-slate-500">
            Arşivlenen programlar burada görünecek.
          </p>
        </div>
      )}
    </>
  );
};

export default StudentDetailHistoryTab;
